import styled from "@emotion/styled";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

import IconShare from "./share.svg";

export const StyledIconContainer = styled(ResponsiveContainer)`
  justify-content: center;
  align-items: center;

  inline-size: 24px;
  block-size: 24px;
`;

export const StyledIconShare = styled(IconShare)`
  ${touchOptimizedStyles};
`;
